import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';

import ErrorMessage from '@/components/shared/ErrorMessage';
import ShortcutList from '@/components/student-dashboard/ShortcutList';
import { Skeleton } from '@/components/ui/daisy';
import { useStudentDashboard } from '@/data/context/StudentDashboardContext';
import useStudentShortcuts from '@/data/hook/student-dashboard/useStudentShortcuts';
import { StudentShortcutType } from '@/utils/student-dashboard/getStudentShortcuts';

const SECTION_HEIGHT = 'h-[5.625rem]';

export default function StudentShortcutsSection() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.shortcuts',
  });
  const { activeCourseProgress, isLoading: isLoadingContext } =
    useStudentDashboard();

  const { shortcuts, isLoading, error } = useStudentShortcuts({
    studentId: activeCourseProgress?.studentId,
    klassId: activeCourseProgress?.klassId,
    slug: activeCourseProgress?.coursePath.slug,
  });

  if (isLoadingContext || isLoading) return <LoadingView />;

  if (error)
    return <ErrorMessage text={t('loadError')} className={SECTION_HEIGHT} />;

  if (!activeCourseProgress) return null;

  return <ShortcutList shortcuts={shortcuts} />;
}

function LoadingView() {
  return (
    <div className="flex w-full gap-4 overflow-hidden">
      {Object.values(StudentShortcutType).map(type => (
        <Skeleton
          key={type}
          className={twJoin(
            SECTION_HEIGHT,
            'w-30 shrink-0 rounded-2xl md:w-auto md:flex-1',
          )}
        />
      ))}
    </div>
  );
}
